import { legacyApiResourceUrl } from "@ploy-lib/core";
import { BaseCamelCasedResource } from "./BaseResource";
//// Not yet implemented
class OptionPairResource extends BaseCamelCasedResource {
    constructor() {
        super(...arguments);
        this.optionPairId = 0;
        this.text = "";
        this.value = "";
        this.description = "";
        this.optionPairCategoryId = 0;
        this.sortOrder = undefined;
        this.optionSource = "";
    }
    pk() {
        return this.optionPairId.toString();
    }
    static listUrl(allParams = {}) {
        const { category } = allParams;
        if (category !== undefined) {
            return `${this.urlRoot}/GetOptionPairsForCategory?category=${category}`;
        }
        throw new Error("OptionPairResource require category");
    }
}
OptionPairResource.urlRoot = legacyApiResourceUrl("OptionPair");
export { OptionPairResource };
class OptionPairCategoryResource extends BaseCamelCasedResource {
    constructor() {
        super(...arguments);
        this.optionPairCategoryId = 0;
        this.name = "";
        this.text = "";
        this.description = "";
        this.editable = false;
        this.optionPairs = [];
    }
    pk() {
        return this.optionPairCategoryId.toString();
    }
}
OptionPairCategoryResource.urlRoot = legacyApiResourceUrl("OptionPair/GetOptionPairCategoriesForExternalUsers");
export { OptionPairCategoryResource };
//# sourceMappingURL=OptionPairResource.js.map